import { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { BACKEND_URL } from "../lib/api";

// Ruta pública: redirige a la página servida por el backend, que siempre envía CSP frame-ancestors (también en producción).
export default function SolicitudPublica() {
  const { linea } = useParams();
  const { search } = useLocation();
  const ok = ["credito", "inversion"].includes(linea);
  useEffect(() => { if (ok) window.location.replace(`${BACKEND_URL}/api/publico/formulario/${linea}${search}`); }, [ok, linea, search]);
  if (!ok) return <main className="p-10 text-center text-sm" data-testid="solicitud-404">Formulario no encontrado</main>;
  return <main className="grid min-h-[100dvh] place-items-center bg-[#F2F0EC] text-sm text-[#5C5850]" data-testid={`solicitud-publica-${linea}`}>Abriendo el formulario…</main>;
}
